import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, DrawerHeader, Svg } from '@gandi/ui';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import CartContentContext from '../../CartContentContext';
import { selectCountItems } from '../../modules/selectors';
import { ConfirmDeletion } from './ConfirmDeletion';
import { DeletionButton } from './DeletionButton';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "closeButton": "Header-closeButton_2FD4P",
  "root": "Header-root_1SjgM",
  "header": "Header-header_2UtkK"
};
export default function Header() {
  const {
    __
  } = useTranslator();
  const [isDeleting, setIsDeleting] = React.useState(false);
  const count = useAppSelector(selectCountItems);
  const {
    hidePanel
  } = React.useContext(CartContentContext);
  const [confirmDeleteCart, setConfirmDeleteCart] = React.useState(false);
  if (confirmDeleteCart) {
    return /*#__PURE__*/_jsx(DrawerHeader, {
      heading: /*#__PURE__*/_jsx(_Fragment, {}),
      className: styles.root,
      children: /*#__PURE__*/_jsx(ConfirmDeletion, {
        setConfirmDeleteCart: setConfirmDeleteCart,
        setIsDeleting: setIsDeleting
      })
    });
  }
  return /*#__PURE__*/_jsxs(DrawerHeader, {
    className: styles.root,
    flex: true,
    flexAlignItemsCenter: true,
    heading: /*#__PURE__*/_jsx(Base, {
      tagName: "span",
      className: styles.header,
      children: __('%(count)s items', {
        count
      })
    }),
    children: [/*#__PURE__*/_jsx(DeletionButton, {
      isDeleting: isDeleting,
      setConfirmDeleteCart: setConfirmDeleteCart
    }), hidePanel && /*#__PURE__*/_jsx(Base, {
      tagName: "button",
      border: "none",
      backgroundColor: "transparent",
      padding: "none",
      onClick: hidePanel,
      className: styles.closeButton,
      children: /*#__PURE__*/_jsx(Svg, {
        name: "miniCrossLight",
        fill: "currentColor"
      })
    })]
  });
}